import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  typeService: '',
  subcategorySelected: null,
  listRecargaServiciosItems: [],
  recargaServicioItemSelected: null,
  recargaServicioItemId: null,
  medioPago: 0,
  recargaServicioData: null
};

const slice = createSlice({
  name: 'dagpacketFlujoRecargaServicio',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    setTypeService(state, action) {
      const type = action.payload;
      state.typeService = type;
    },

    setSubcategorySelected(state, action) {
      const subcategory = action.payload;
      state.subcategorySelected = subcategory;
    },

    setlistRecargaServiciosItems(state, action) {
      const data = action.payload;
      state.listRecargaServiciosItems = data;
    },
    setRecargaServicioItemSelected(state, action) {
      const data = action.payload;
      state.recargaServicioItemSelected = data;
    },
    setRecargaServicioDataServRec(state, action) {
      const data = action.payload;
      state.recargaServicioData = data;
    },
    setRecargaServicioItemId(state, action) {
      const id = action.payload;
      state.recargaServicioItemId = id;
    },
    getMedioPago: (state, action) => {
      const medioPago = action.payload;
      state.medioPago = medioPago;
    }
  }
});

// Reducer
export default slice.reducer;

export const {
  setTypeService,
  setSubcategorySelected,
  setlistRecargaServiciosItems,
  setRecargaServicioItemSelected,
  setRecargaServicioItemId,
  setRecargaServicioDataServRec,
  getMedioPago
} = slice.actions;

// ----------------------------------------------------------------------

export function getLabels() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/mail/labels');
      dispatch(slice.actions.getLabelsSuccess(response.data.labels));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getMails(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/mail/mails', { params });
      dispatch(slice.actions.getMailsSuccess(response.data.mails));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getMail(mailId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/mail/mail', {
        params: { mailId }
      });
      dispatch(slice.actions.getMailSuccess(response.data.mail));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
